import React, { useEffect, useState } from 'react';
import { Download, Zap, Sparkles } from 'lucide-react';
import { Button } from '@/components/Button';

export const InstallPromptBanner: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const handler = (e: Event) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            // Update UI notify the user they can install the PWA
            setShowBanner(true);
        };

        window.addEventListener('beforeinstallprompt', handler);
        const standalone = window.matchMedia('(display-mode: standalone)').matches;
        const iosStandalone = (window.navigator as any).standalone === true;

        // Se o a pessoa chegou da App, o display-mode é 'standalone'
        if (standalone || iosStandalone) {
            setShowBanner(false); // Já está instalado e usado pelo App
        }

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setShowBanner(false);
        }
        setDeferredPrompt(null);
    };

    if (!showBanner) return null;

    return (
        <div className="mb-8 mt-4 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 p-[2px] rounded-3xl animate-in fade-in zoom-in-95 duration-500 shadow-2xl shadow-blue-500/20 max-w-4xl mx-auto relative group overflow-hidden">
            <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="bg-white/95 dark:bg-gray-900/95 rounded-[22px] px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-6 backdrop-blur-xl relative z-10">
                <div className="flex items-center gap-5 text-center md:text-left flex-col md:flex-row">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 dark:from-blue-900/40 dark:to-purple-900/40 rounded-2xl flex items-center justify-center shrink-0 border border-blue-200 dark:border-blue-800/50 shadow-inner">
                        <Zap className="w-8 h-8 text-blue-600 dark:text-blue-400" />
                    </div>
                    <div>
                        <h3 className="text-xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-700 to-purple-700 dark:from-blue-400 dark:to-purple-400 flex items-center gap-2 justify-center md:justify-start">
                            Baixe o App do Radar <Sparkles className="w-5 h-5 text-amber-500" />
                        </h3>
                        <p className="text-sm font-semibold text-gray-600 dark:text-gray-400 mt-1.5 max-w-md leading-relaxed">
                            Otimize na velocidade da luz! Clique no botão "Compartilhar" direito nas outras lojas para a gente preencher o link pra você!
                        </p>
                    </div>
                </div>

                <Button
                    onClick={handleInstallClick}
                    variant="primary"
                    className="w-full md:w-auto h-12 shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 hover:-translate-y-0.5 transition-all px-8 bg-gradient-to-r from-blue-600 to-indigo-600"
                >
                    <Download className="w-4 h-4 mr-2" />
                    <span className="font-bold">Instalar APP</span>
                </Button>
            </div>
        </div>
    );
};
